import { takeLatest, put, call, delay } from 'redux-saga/effects';
import * as type from '../../redux/types/trans';
import Api from '../../services/trans/trans';

let allApi = new Api();

async function fetchUser(data) {
    let res = await allApi.commonGet(data);
    return res;

}

function* fetchData(action) {

    let payload = {
        "apiName": "GetCartDetails",
        "params": ""
    }
    let apiresponse = yield call(fetchUser, payload)
    if (apiresponse?.data?.success === true) {
        let allData = apiresponse?.data?.data;

        yield put({ type: type.GET_CART_SUCCESS, payload: allData })
    } else {
        yield put({ type: type.GET_CART_FAILURE, payload: {} })
    }


}

export function* getCartData() {
    yield takeLatest(type.GET_CART_PENDING, fetchData)
}